var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKanfastWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 988 175",
    width: 988,
    height: 175,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KANFAST_Black-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m227.2 27.8l-51.7 44.9 36.5 74.3h-39.8l-22.5-51.7-26 22.4-6.1 29.3h-37.2l25.5-119.2h37.2l-9.7 44.5 0.3 0.4 45-44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m335.4 147h-36.1l-1.6-19.5h-38.9l-9.3 19.5h-39.7l67.4-119.2h39.3zm-40.1-44.9l-3.7-43.4h-0.3l-20.5 43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m488.2 27.8l-25.6 119.2h-34.5l-29.6-69.3h-0.3l-14.8 69.3h-34.6l25.6-119.2h34.5l29.3 69.4h0.4l14.9-69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m604.6 27.8l-5.5 25.4h-54.6l-4.7 21.3h53.5l-5.3 24.2h-53.7l-9.8 48.3h-36.8l25.4-119.2h91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m700.6 147h-36.2l-1.6-19.5h-38.9l-9.2 19.5h-39.7l67.3-119.2h39.3zm-40.1-44.9l-3.7-43.4h-0.3l-20.5 43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m832.3 60.9l-34.5 1.8q-1.1-15.5-17.3-15.5-6.6 0-10.1 2.8-3.5 2.8-3.5 6.7 0 2.8 2.8 5.4 2.9 2.6 13.5 6.6 13.5 5.2 22 9.8 8.4 4.6 13.8 12 5.4 7.4 5.4 18.5 0 10.4-5.8 19.4-5.9 9-16.8 14.8-10.9 5.8-31.1 5.8-28.4 0-40.3-10.9-11.9-10.9-11.9-27.9v-2.8l34.7-2.4q0 11.2 4.9 15.8 4.9 4.6 13.6 4.6 8.8 0 13.4-3.9 4.6-3.8 4.6-8.7 0-3.6-2.9-6.7-2.9-3.1-14.4-7.2-26.3-9.5-33.2-17.5-7-7.9-7-19.2 0-10.2 5.8-18.7 5.7-8.4 16.6-13.1 11-4.7 26.3-4.7 48.3 0 51.4 35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m964.3 27.8l-6.1 29.2h-38.8l-19.4 90h-37l19.4-90h-37.1l6.2-29.3c0 0 112.8 0 112.8 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m107.2 108.3c-0.3-9.9 1.6-19.8 3.5-29.3q0.8-3.4 1.7-6.7c1.6-14.8 2.4-29.7 3.7-44.6h-12.5q-0.3 0-0.6 0.1h-59.5c-1.9 0-3.4 1.9-3.4 4.3 0 1.2 0.4 2.3 1 3.1 0.6 0.7 1.5 1.2 2.5 1.2h50q0 0 0.1 0h4.3c1.9 0 3.5 2 3.5 4.4v1.9c0 2.3-1.6 4.3-3.5 4.3h-5.5q-0.1 0-0.2 0h-38.9c-1.9 0-3.4 2-3.4 4.4 0 1.2 0.4 2.3 1 3 0.6 0.8 1.5 1.3 2.5 1.3h37.7q0.1 0 0.2 0.1h7.8c1.7 0 3.1 1.7 3.1 3.8v2.5c0 2.1-1.4 3.8-3.1 3.8h-11.6q-0.1 0-0.1 0h-34.1c-1.9 0-3.4 2-3.4 4.4 0 1.2 0.4 2.2 1 3 0.6 0.8 1.5 1.3 2.5 1.3h35.5q0 0 0.1 0h6.3c1.7 0 3.1 1.8 3.1 3.9v2.4c0 2.2-1.4 3.9-3.1 3.9h-7.4q-0.1 0-0.1 0h-23.7c-1.9 0-3.5 2-3.5 4.4 0 1.2 0.4 2.2 1.1 3 0.6 0.8 1.5 1.3 2.4 1.3h17.2q0.1 0 0.2 0h11.6c1.7 0 3.1 1.7 3.1 3.8v2.1c0 2.2-1.4 3.9-3.1 3.9h-36.8c-1.9 0-3.5 2-3.5 4.3 0 1.2 0.4 2.3 1 3.1 0.7 0.8 1.5 1.3 2.5 1.3h22.4q0.1 0 0.1 0h11.6c1.7 0 3.1 1.7 3.1 3.8v1c0 2.1-1.4 3.8-3.1 3.8h-11.6q-0.1 0-0.2 0h-40.4c-1.9 0-3.5 2-3.5 4.4 0 1.1 0.4 2.2 1 3 0.7 0.8 1.5 1.3 2.5 1.3h51.3c1.7 0 3.1 1.7 3.1 3.9v1.3c0 2.1-1.4 3.9-3.1 3.9h-11.6q-0.1-0.1-0.3-0.1h-30.6c-1.9 0-3.4 2-3.4 4.4 0 1.2 0.3 2.2 1 3 0.6 0.8 1.5 1.3 2.4 1.3h56.6c0.4-13 1.7-25.9 3.5-38.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36.9 56.8h-13.4c-2.3 0-4.2-1.9-4.2-4.2 0-2.3 1.9-4.2 4.2-4.2h13.4c2.3 0 4.1 1.9 4.1 4.2 0 2.3-1.8 4.2-4.1 4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m46.4 91.2h-12.4c-2.3 0-4.2-1.9-4.2-4.2 0-2.3 1.9-4.1 4.2-4.1h12.4c2.3 0 4.1 1.8 4.1 4.1 0 2.3-1.8 4.2-4.1 4.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m878.9 121.5c-0.1-6.5 1.1-13.1 2.4-19.4q0.4-2.2 1-4.4c1.1-9.7 1.7-19.6 2.5-29.4h-8.3q-0.1 0-0.3 0.1h-39.2c-1.3 0-2.3 1.2-2.3 2.8 0 0.8 0.2 1.5 0.6 2 0.5 0.6 1 0.9 1.7 0.9h32.9q0.1 0 0.1 0h2.9c1.3 0 2.3 1.3 2.3 2.9v1.2c0 1.6-1.1 2.9-2.3 2.9h-3.7q0 0-0.1 0h-25.6c-1.3 0-2.3 1.3-2.3 2.9 0 0.8 0.3 1.5 0.7 2 0.4 0.5 1 0.8 1.6 0.8h24.9q0 0 0.1 0.1h5.2c1.1 0 2 1.1 2 2.5v1.6c0 1.4-0.9 2.6-2 2.6h-7.7q0 0-0.1 0h-22.4c-1.3 0-2.3 1.2-2.3 2.8 0 0.8 0.3 1.5 0.7 2 0.4 0.6 1 0.9 1.6 0.9h23.4q0.1 0 0.1 0h4.2c1.1 0 2 1.2 2 2.6v1.6c0 1.4-0.9 2.5-2 2.5h-5q0 0 0 0h-15.6c-1.3 0-2.3 1.3-2.3 2.9 0 0.8 0.2 1.5 0.7 2 0.4 0.5 0.9 0.8 1.6 0.8h11.3q0.1 0 0.2 0h7.6c1.1 0 2 1.2 2 2.6v1.4c0 1.4-0.9 2.5-2 2.5h-24.3c-1.2 0-2.2 1.3-2.2 2.9 0 0.8 0.2 1.5 0.6 2 0.4 0.5 1 0.9 1.6 0.9h14.8q0.1 0 0.1 0h7.6c1.2 0 2.1 1.1 2.1 2.5v0.6c0 1.4-0.9 2.6-2.1 2.6h-7.6q0 0-0.1 0h-26.7c-1.3 0-2.3 1.2-2.3 2.8 0 0.8 0.3 1.5 0.7 2.1 0.4 0.5 1 0.8 1.6 0.8h33.8c1.1 0 2.1 1.1 2.1 2.5v0.9c0 1.4-1 2.6-2.1 2.6h-7.6q-0.1 0-0.2 0h-20.2c-1.3 0-2.3 1.2-2.3 2.8 0 0.8 0.3 1.5 0.7 2 0.4 0.6 1 0.9 1.6 0.9h37.4c0.2-8.7 1.1-17.2 2.2-25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m832.5 87.5h-8.8c-1.5 0-2.7-1.3-2.7-2.8 0-1.5 1.2-2.7 2.7-2.7h8.8c1.6 0 2.8 1.2 2.8 2.7 0 1.5-1.2 2.8-2.8 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m838.8 110.2h-8.1c-1.6 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.7 2.8-2.7h8.1c1.6 0 2.8 1.2 2.8 2.8 0 1.5-1.3 2.7-2.8 2.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanfastWhite);
export default __webpack_public_path__ + "static/media/KANFAST_White.286bd85fe62440572c06dc9556f594b9.svg";
export { ForwardRef as ReactComponent };